import './commonAssets';

import '../graphicstock/components/markup-mixins.less';
import '../common/stylesheets/modules/widgets/testimonials.less';
import '../global/vendor/bootstrap/lib/carousel.less';
import '../storyblocks/stylesheets/modules/home/storyblocks-homepage.less';
import '../storyblocks/stylesheets/modules/home/storyblocks-about-us.less';
import '../storyblocks/stylesheets/modules/marketing/reStock.less';
import '../storyblocks/stylesheets/modules/marketing/reStockV2.less';
import '../storyblocks/stylesheets/modules/shared/team-wrapper-images-and-content.less';
import '../storyblocks/stylesheets/modules/shared/storyblocks-hero.less';
import '../storyblocks/stylesheets/modules/about/about-us.less';
import '../common/stylesheets/modules/signup/user-lead-form-innards.less';
import '../common/stylesheets/modules/signup/user-lead-form-drop-shadow.less';
import '../global/components/storyblocks-collection-browse.less';
import '../audioblocks/stylesheets/modules/home/audio-home-hero.less';
import '../global/vendor/tailwind/tailwind.less';
import '../react/app/Search/components/card/AudioStockItemCard.less';
import '../global/tools/mixins.less';

import '../common/stylesheets/shapes.less';
import '../common/stylesheets/modules/widgets/plans-and-pricing.less';
import '../common/stylesheets/modules/widgets/full-width-background-widget.less';
import '../common/stylesheets/modules/hero/hero.less';

import AppLoader from '../react/AppLoader/AppLoader';
import AudioStockItemCard from '../react/app/Search/components/card/AudioStockItemCard';
import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import AudioContainer from '../react/Audio/containers/AudioContainer';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [],
  auxApps: {
    ...NavApps,
    'pop-up-container': PopUpsContainer,
    'audio-app': AudioContainer,
    'nps-modal': NPSModalLoaderContainer,
  },
  propBasedApps: {
    audioStockItemCard: AudioStockItemCard,
    'entTrialBanner': EntTrialBanner
  },
});
